import { render, staticRenderFns } from "./create-order-form-component.vue?vue&type=template&id=4f74f65c&scoped=true"
import script from "./create-order-form-component.vue?vue&type=script&lang=js"
export * from "./create-order-form-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74f65c",
  null
  
)

export default component.exports